import { useMemo } from "react";
import SearchInput from "components/atoms/input/search/SearchInput";
import ThumbnailImageGrid from "./ThumbnailImageGrid";
import { toTrim } from "utils/functions";

interface Props {
  cameraKeyword: string;
  selectedCameraId: string;
  onChangeCameraKeyword: (keyword: string) => void;
  onSelectCamera: (cameraId: string) => void;
}

export default function CameraThumbnailModal({
  cameraKeyword,
  selectedCameraId,
  onChangeCameraKeyword,
  onSelectCamera,
}: Props): JSX.Element {
  const dummyCameraList = useMemo(
    () => [
      {
        id: "cam-01",
        name: "Entrance Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1518770660439-4636190af475?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-02",
        name: "Warehouse Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-03",
        name: "Loading Dock Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-04",
        name: "Back Door Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1473445361085-b9a07f55608b?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-05",
        name: "Office Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-06",
        name: "Parking Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-07",
        name: "Lobby Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-08",
        name: "Server Room Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-09",
        name: "Floor 2 Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-10",
        name: "Hallway Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1497366412874-3415097a27e7?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-11",
        name: "Assembly Camera",
        imageUrl:
          "https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=640&q=80&auto=format&fit=crop",
      },
      {
        id: "cam-12",
        name: "Dock Camera 2",
        imageUrl:
          "https://images.unsplash.com/photo-1513828583688-c52646db42da?w=640&q=80&auto=format&fit=crop",
      },
    ],
    []
  );

  const filteredCameraList = useMemo(() => {
    const keyword = toTrim(cameraKeyword).toLowerCase();
    if (!keyword) return dummyCameraList;
    return dummyCameraList.filter((camera) =>
      camera.name.toLowerCase().includes(keyword)
    );
  }, [cameraKeyword, dummyCameraList]);

  return (
    <>
      <SearchInput
        keyword={cameraKeyword}
        onClickSearch={(keyword: string) => onChangeCameraKeyword(keyword)}
        placeholder="Search Camera"
      />

      <ThumbnailImageGrid
        items={filteredCameraList}
        selectedId={selectedCameraId}
        onSelect={onSelectCamera}
      />
    </>
  );
}
